import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const CheckSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.62686 10.0749C6.64881 10.0968 6.68442 10.0968 6.70638 10.0749L12.3233 4.45733C12.5836 4.19698 13.0057 4.19689 13.2661 4.45714C13.5267 4.71751 13.5268 5.13982 13.2663 5.40028L6.71773 11.9488C6.6895 11.9771 6.64373 11.9771 6.6155 11.9488L2.89528 8.22863C2.63497 7.96832 2.63497 7.54627 2.89528 7.28596C3.15559 7.02565 3.57764 7.02565 3.83795 7.28596L6.62686 10.0749Z"
      fill="#273F32"
    />
  </svg>
);

const Check = (props: IIconProps) => <Icon component={CheckSvg} {...props} />;

export default Check;
